import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { OnboardingHeader } from "@shared-kernel/primary/shared/onboarding/onboarding-header";
import { SpinnerWithText } from "@shared-kernel/primary/shared/ui/spinner";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import { ImpersonationBanner } from "@user-management-context/primary/shared/impersonation-banner/impersonation-banner";

export const OnboardingLayout = () => {
  const { user } = useSession();

  return (
    <>
      <ScrollRestoration />
      <ImpersonationBanner />
      <div className="mx-auto my-5 w-full max-w-2xl space-y-8 px-4">
        {user && <OnboardingHeader userName={user.name} />}
        <Suspense
          fallback={
            <div className="flex h-64 items-center justify-center">
              <SpinnerWithText text="Chargement..." />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
    </>
  );
};
